export namespace Query {

    export type Params = { [key: string]: string[] }

    export const getParams = (): Params => {

        // Get params from loaction
        const rawParams = window.location.search.replace('?', '').split('&');

        // Transform our params
        const params: Params = {}
        rawParams.forEach(param => {
            const split = param.split('=')
            if (!params[split[0]]) {
                params[split[0]] = []
            }
            params[split[0]].push(split[1])
        })

        return params
    }

    export const setParams = (params: Params) => {
        let query = '?';
        Object.keys(params).forEach(key => {
            if (key !== "") {
                params[key].forEach(param => {
                    query += `${key}=${param}&`
                })
            }

        })
        window.history.replaceState(undefined, undefined, query.substr(0, query.length - 1));
    }
}